export default function Message({ notice }) {
  if (!notice?.text) return null;
  return <div className={`alert alert-${notice.type || "info"}`}>{notice.text}</div>;
}
